import React, { useEffect, useState } from 'react';
import Input from '../../../shared/forms/Input';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';
import TooltipTrigger from '../../../shared/components/TooltipTrigger';
import TrackingCodeSection from '../../../shared/components/TrackingCodeSection';
import {
  normalizeSiteDomain,
  SITE_DOMAIN_HINT,
  validateSiteDomain,
} from './siteDomainValidation';

const EditSiteModal = ({ oldDomain, saveDomain, setEditedIndex, existingNames }) => {
  const [domain, setDomain] = useState(oldDomain);
  const initialValidation = validateSiteDomain({
    value: oldDomain,
    existingNames,
    currentValue: oldDomain,
  });
  const [message, setMessage] = useState(initialValidation.message);
  const [disabled, setDisabled] = useState(Boolean(initialValidation.message));
  const [showDomainAttention, setShowDomainAttention] = useState(false);

  useEffect(() => {
    if (!showDomainAttention) return undefined;

    const timeoutId = window.setTimeout(() => {
      setShowDomainAttention(false);
    }, 900);

    return () => window.clearTimeout(timeoutId);
  }, [showDomainAttention]);

  const triggerDomainAttention = () => {
    setShowDomainAttention(false);
    window.requestAnimationFrame(() => {
      setShowDomainAttention(true);
    });
  };

  const closeModal = () => setEditedIndex(-1);

  return (
    <Modal isOpen={true} onClose={closeModal} className="modal--medium modal--full-height">
      <div className="modal">
        <div className="modal__header">
          <h3 className="margin-none">Edit website</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close edit website modal"
          />
        </div>

        <div className="modal__body">
          <form
            id="edit-site-form"
            onSubmit={(e) => {
              e.preventDefault();

              if (disabled) {
                triggerDomainAttention();
                return;
              }

              saveDomain(normalizeSiteDomain(domain));
              closeModal();
            }}
          >
            <div className="modal-section">
              <h4 className="modal-section__title">Site information</h4>

              <div className="field-stack">
                <Input
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    const nextValidation = validateSiteDomain({
                      value: nextValue,
                      existingNames,
                      currentValue: oldDomain,
                    });

                    setDomain(nextValue);
                    setMessage(nextValidation.message);
                    setDisabled(Boolean(nextValidation.message));
                  }}
                  label="Domain name"
                  value={domain}
                  placeholder="example.com"
                  className={showDomainAttention ? 'is-attention' : ''}
                  icon={<TooltipTrigger text={SITE_DOMAIN_HINT} />}
                />
                {message && (
                  <p className="field-message">
                    {message}
                  </p>
                )}
              </div>
            </div>

            <TrackingCodeSection />
          </form>
        </div>

        <div className="modal__footer">
          <button
            type="button"
            className="btn secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="edit-site-form"
            className={'btn primary' + (disabled ? ' disabled' : '')}
            aria-disabled={disabled}
            onClick={() => {
              if (disabled) {
                triggerDomainAttention();
              }
            }}
          >
            Save changes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditSiteModal;
